module.exports = __webpack_public_path__ + "img/bedon.d4dced0c.svg";